import React from 'react';

function Categories(): JSX.Element {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Categories</h1>
      <p className="text-gray-500">Explore various categories of our products.</p>
    </div>
  );
}

export default Categories;
